import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.194 2.816a7.339 7.339 0 0 1-6.43 12.421C5.371 15 4.835 13.3 5.828 12.305l1.107-1.107a1.507 1.507 0 0 0 0-2.124 1.507 1.507 0 0 0-2.124 0L3.705 10.18c-.994.994-2.696.456-2.933-.935a7.338 7.338 0 0 1 12.421-6.43m-.47.47a6.674 6.674 0 0 0-11.3 5.85 1.067 1.067 0 0 0 1.811.575l1.108-1.107a2.174 2.174 0 0 1 3.063 0c.843.843.843 2.22 0 3.064L6.3 12.775c-.62.619-.28 1.665.576 1.811a6.674 6.674 0 0 0 5.849-11.3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.094 3.024A1.41 1.41 0 1 1 8.1 5.016a1.41 1.41 0 0 1 1.994-1.992m-.47.47a.744.744 0 1 0-1.053 1.053.744.744 0 0 0 1.053-1.053M12.986 5.916a1.41 1.41 0 1 1-1.995 1.992 1.41 1.41 0 0 1 1.995-1.992m-.47.47a.744.744 0 1 0-1.053 1.053.744.744 0 0 0 1.053-1.053M6.159 3.748a1.409 1.409 0 1 1-1.992 1.993 1.409 1.409 0 0 1 1.992-1.993m-.47.47a.744.744 0 1 0-1.053 1.053.744.744 0 0 0 1.053-1.053M12.262 9.85a1.409 1.409 0 1 1-1.992 1.993 1.409 1.409 0 0 1 1.992-1.992m-.47.47a.744.744 0 1 0-1.053 1.054.744.744 0 0 0 1.053-1.053"
    }, null, -1)
  ]))]))
}
export default { render: render }